/**
 * Sequência do "Tentar mais uma vez" do quiz — tentativa nova, não rodada de
 * vidas da mesma tentativa.
 *
 * 1. `clearSubmitted` zera o conjunto da tentativa anterior: as perguntas dela
 *    não voltam a valer.
 * 2. `loadQuestions` traz o conjunto da próxima tentativa (`quiz_questions/
 *    next` com a anterior encerrada devolve a pool inteira; `repeat_chances`
 *    esgotado devolve vazio e a fonte esgotada leva à conclusão). Serializado
 *    antes do restart do motor para o start não rodar sobre a lista velha.
 * 3. `onRestart` restaura vidas e volta à tela inicial.
 *
 * A re-busca falhando não prende o participante na tela de sem vidas: o erro é
 * logado e o restart acontece mesmo assim — o conjunto zerado impede o start
 * de reenviar perguntas respondidas, e o pior caso é repetir questões que o
 * backend aceita reenviar na tentativa nova.
 */
export const restartQuizAttempt = async ({
  clearSubmitted,
  loadQuestions,
  onRestart,
  logError = console.warn
}) => {
  clearSubmitted()
  try {
    await loadQuestions()
  } catch (error) {
    logError('Falha ao recarregar as perguntas do quiz', error)
  } finally {
    onRestart()
  }
}
